// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapPop[data-v-095d7dd4] .van-popup /deep/ .container{width:85vw;padding:2.667vw 3%;box-sizing:border-box;border-radius:.667vw}.wrapPop[data-v-095d7dd4] .van-popup /deep/ .container /deep/ .van-cell__title{width:3em}.wrapPop[data-v-095d7dd4] .van-popup /deep/ .container .tip{padding:.667vw 3%;font-size:2.933vw;color:#999}.wrapPop[data-v-095d7dd4] .van-popup /deep/ .container .submit{height:10vw;line-height:10vw;margin-top:2vw;font-size:3.2vw}", ""]);
// Exports
module.exports = exports;
